import React from 'react';
import styled from 'styled-components';
import { useSaved } from '../context/SavedContext';
import { useExperiences } from '../context/ExperiencesContext';
import { getRecommendations } from '../utils/recommendations';
import AuthPanel from './AuthPanel';
import BentoGrid from './BentoGrid';

const Container = styled.div`
  min-height: 100vh;
  padding: 20px;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #00f5ff, #ff00aa);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin-top: 8px;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

function RecommendationsPage({
  onBack,
  onExperienceClick,
  onNavigateToSaved,
  onNavigateToRecommendations,
  onNavigateToCreate,
  onNavigateToMyUploads,
  onNavigateToReview,
  canCreatePost,
  canReview
}) {
  const { savedIds, requestSave, isSaved } = useSaved();
  const { experiences } = useExperiences();
  const recommended = getRecommendations(savedIds, 12, experiences);

  return (
    <Container>
      <TopBar>
        <BackButton type="button" onClick={onBack}>
          ← Back
        </BackButton>
        <AuthPanel
          onNavigateToSaved={onNavigateToSaved}
          onNavigateToRecommendations={onNavigateToRecommendations}
          onNavigateToCreate={onNavigateToCreate}
          onNavigateToMyUploads={onNavigateToMyUploads}
          onNavigateToReview={onNavigateToReview}
          canCreatePost={canCreatePost}
          canReview={canReview}
        />
      </TopBar>
      <Header>
        <Title>Recommended for you</Title>
        <Subtitle>
          {savedIds.length > 0
            ? 'Based on your saved experiences'
            : 'Save some experiences to get personalized recommendations'}
        </Subtitle>
      </Header>
      <BentoGrid
        experiences={recommended}
        onExperienceClick={onExperienceClick}
        showSaveButton
        isSaved={isSaved}
        onSaveClick={requestSave}
      />
    </Container>
  );
}

export default RecommendationsPage;
